import { Injectable } from '@angular/core';
import { Result } from 'src/app/core/models/results/result.model';
import { Simulation } from 'src/app/core/models/simulation.model';
import { DataSharingService } from '../../data-sharing/data-sharing.service';
import { SimulationManagerService } from '../simulation-manager.service';

@Injectable({
  providedIn: 'root',
})
export class ResultsService {
  constructor(
    private simulationService: SimulationManagerService,
    private dataSharingService: DataSharingService,
  ) {}

  get(): Result {
    return this.result || this.create();
  }

  triggerEffects(): void {
    this.simulationService.changeSimulation();
    this.dataSharingService.updateErrorsLog$.next();
  }

  private create(): Result {
    if (this.result) {
      return this.result;
    }
    const newResult = new Result();
    newResult.lineResultsRequesters = [];
    newResult.staticEnvelopeIntervalInit = 0;
    newResult.staticEnvelopeIntervalEnd = 1;
    newResult.dynamicEnvelopeIntervalInit = 0;
    newResult.dynamicEnvelopeIntervalEnd = 1;
    newResult.variablesEnvelop = [];
    newResult.variablesTimeHistory = [];
    this.simulation.results = [newResult];
    this.triggerEffects();
    return this.result;
  }

  private get simulation(): Simulation {
    return this.simulationService.simulation;
  }

  private get result(): Result {
    return this.simulation.results?.[0];
  }
}
